import { Box, IconButton, useTheme } from "@mui/material";
import React, { useState } from "react";
import { useContext } from "react";
import { ColorModeContext, tokens } from "../../theme";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import { useNavigate, useLocation } from "react-router-dom";



const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const userRole = localStorage.getItem("role");
  const loginName = localStorage.getItem("loginName");

  const navigate = useNavigate();
  const location = useLocation();


  const handleLogout = () => {
    localStorage.clear();
    window.location.href = window.location.origin;
  };


  return (
    <div className="flex justify-end">
      <div className="flex items-center justify-between">
        <div className="flex items-center ml-2 space-x-4">
          {/* User Info */}
          <div>
            <h4 className="text-sm font-semibold text-black">{loginName}</h4>
            <p className="text-xs text-gray-400">{userRole}</p>
          </div>

          {/* Icon as Avatar */}
          {/* Icon as Avatar */}
          <div className="w-10 h-10 shadow-xl rounded-full cursor-pointer overflow-hidden bg-white flex items-center justify-center">
            <PersonOutlinedIcon
               onClick={(e) => {
                e.preventDefault();
                toggleDropdown();
              }}
              className="text-gray-600"
              style={{ width: "24px", height: "24px" }}
            />
          </div>
        </div>

        <button
          onClick={(e) => {
            e.preventDefault();
            toggleDropdown();
          }}
          className="ml-2 text-gray-500 hover:text-black"
        >
          <span className="text-2xl">⋮</span>
        </button>

        {isOpen && (
          <ul
            className="absolute right-0 mt-40 w-48 border border-gray-200 rounded-lg shadow-lg z-10"
            style={{ backgroundColor: colors.primary[400] }}
          >
            <li
              className="p-4 text-center list-none font-semibold text-red-600 cursor-pointer hover:bg-red-100"
              onClick={handleLogout}
            >
              Logout
            </li>
          </ul>
        )}
      </div>
    </div>

  );
};

export default Topbar;
